module.exports = __webpack_public_path__ + "static/media/Trading_Up_Mobile_Banner_STAKE@1x.e521c726.jpg";